export default {
  item_cost: 'number',
  purchase_id: 'number',
  qty: 'number'
}



// WEBPACK FOOTER //
// ./src/store/models/purchase.js